import { QuoteStage } from '../types';

export const findQuoteLabel = (
    quoteStages: QuoteStage[],
    quoteValue: string
) => {
    if (!quoteStages || !quoteValue) {
        return undefined;
    }
    return quoteStages.find(quoteStage => quoteStage.value === quoteValue)
        ?.label;
};
